module.exports = __webpack_public_path__ + "media/images/top-content-img-13-b5e68a02c99d1a5b1980ead6f46d87a2.jpg";